<template>
  <div style="width: 100%; height: 100%; position: absolute">
    <h1
      style="width: 100%; height: 70px; position: absolute; color: white; font-weight: bold; font-size: 42px; line-height: 70px; padding-left: 20px; text-align: left">
      Subcontractors Non-conformance (Cumulative)
    </h1>
    <div v-if="dataNotNull" key="1" class="safetyDiv" style="width: 100%; height: 793px; position: absolute; bottom: 0">
      <div class="container1" style="height: 100%;"></div>
    </div>
    <div v-else key="2"
         style="width: 100%; height: 793px; position: absolute; bottom: 0; line-height: 793px; color: #6CF; font-size: 64px;">
      No Data !
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import axios from 'axios'

export default {

  name: "safety",

  props: ['project_id'],

  data() {
    return {
      my_project_id: this.project_id,
      legendArr: [],
      color: this.$store.state.color.chart_color,
      myChart: null,
      name: "safety",
      dataNotNull: true
    }
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.clear()
    }
  },
  methods: {
    init() {
      // this.$root.charts.push(this.myChart)
      window.addEventListener("resize", function () {
        this.myChart.resize()
      }.bind(this))
    },

    analysisResult(result) {
      var safetys = []
      var legends = []
      for (var i in result) {
        var legen = result[i].contractor_name.split(/[ ]+/)
        var count = result[i].count
        var legend = []
        for (var i in legen) {
          var str = legen[i]
          if (str.indexOf('(') != -1) {
            if (str.indexOf(')') != -1) {
              legend.push(str)
            } else {
              legend.push(str.substr(0, 2))
            }
          } else if (str.indexOf(')') != -1) {
            legend.push(str.charAt(0))
            if (str.indexOf(')') != 0) {
              legend.push(')')
            }
          } else {
            legend.push(str.charAt(0))
          }
        }
        legends.push(legend.join(''))
        safetys.push(count)
      }
      return {legends: legends, safetys: safetys}
    }
  },
  mounted() {
    let that = this
    var name = window.localStorage.getItem('token_key')
    if ("videmo" == name) {
      this.my_project_id = "3177"
    }
    this.myChart = echarts.init(document.querySelector('.safetyDiv .container1'))
    this.myChart.setOption({
      grid: {
        bottom: 100
      },
      tooltip: {
        show: true,
        trigger: 'axis',
        textStyle: {
          fontSize: 40
        }
      },
      xAxis: {
        type: "category",
        data: [],
        axisLine: {
          lineStyle: {
            color: '#FFF',
          }
        },
        axisLabel: {
          interval: 0,
          fontSize: 36
        }
      },
      yAxis: {
        type: 'value',
        minInterval: 1,
        axisLine: {
          lineStyle: {
            color: '#6CF',
          },

        },
        axisLabel: {
          fontSize: 42
        }
      },
      series: [{
        data: [],
        barWidth: '25%',
        barCategoryGap: '5%',
        type: 'bar',
        itemStyle: {
          normal: {
            color: function (params) {
              return that.color[params.dataIndex]
            }
          },
          //鼠标悬停时：
          emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }],
    })

    this.myChart.showLoading({
      text: '',
      color: '#66CCFF',
      maskColor: 'rgba(255, 255, 255, 0)',
    });

    let postData = {
      project_id: this.my_project_id,
      user: window.localStorage.getItem("token_key"),
      token: window.localStorage.getItem('token'),
      // start_date: this.getNowFormatDate(),
      // end_date: this.getNowFormatDate()
    }
    axios.post(this.$store.getters.getCmsServer + "DBProjSubNonCon", postData).then(resp => {
      var errNo = resp.data.errno
      var errStr = resp.data.errstr_cn
      this.myChart.hideLoading()
      if (errNo == "0") {
        this.dataNotNull = true
        var result = resp.data.result;
        var data = this.analysisResult(result)
        this.myChart.setOption({
          xAxis: {
            data: data.legends,
          },
          series: [
            {
              data: data.safetys
            }
          ]
        })
      } else {
        this.dataNotNull = false
      }
    }).catch(error => {
      alert(error)
      this.myChart.hideLoading()
      this.dataNotNull = false
    })


    // this.init()
  }
}
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/components/safety_manage/safety.vue